module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }